import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { useEffect } from 'react'
import TopBar from './sections/TopBar'
import Footer from './sections/Footer'
import HomePage from './pages/HomePage'
import VerifyPage from './pages/VerifyPage'
import SignPage from './pages/SignPage'
import HashSignPage from './pages/HashSignPage'
import DownloadPage from './pages/DownloadPage'
import DocsPage from './pages/DocsPage'
import HakkimizdaPage from './pages/HakkimizdaPage'
import DestekPage from './pages/DestekPage'
import GizlilikPage from './pages/GizlilikPage'
import NotFoundPage from './pages/NotFoundPage'
import RedirectSignPage from './pages/RedirectSignPage'
import RequireAuth from './components/RequireAuth'
import LoginPage from './pages/portal/LoginPage'
import AuthCallbackPage from './pages/portal/AuthCallbackPage'
import DashboardPage from './pages/portal/DashboardPage'
import AccountPage from './pages/portal/AccountPage'
import DeveloperPage from './pages/portal/DeveloperPage'
import ComposeDocumentPage from './pages/portal/ComposeDocumentPage'
import UploadDocumentPage from './pages/portal/UploadDocumentPage'
import DocumentDetailPage from './pages/portal/DocumentDetailPage'
import RecipientSignPage from './pages/portal/RecipientSignPage'

function ScrollToTop() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (hash) return
    window.scrollTo({ top: 0, behavior: 'auto' })
  }, [pathname, hash])
  return null
}

function Shell() {
  return (
    <div className="relative min-h-screen flex flex-col">
      <TopBar />
      <ScrollToTop />
      <main id="main" className="flex-1">
        <Routes>
          <Route path="/"                element={<HomePage />} />
          <Route path="/verify"          element={<VerifyPage />} />
          <Route path="/sign"            element={<SignPage />} />
          <Route path="/hash-sign"       element={<HashSignPage />} />
          <Route path="/download"        element={<DownloadPage />} />
          <Route path="/docs"            element={<DocsPage />} />
          <Route path="/hakkimizda"      element={<HakkimizdaPage />} />
          <Route path="/destek"          element={<DestekPage />} />
          <Route path="/gizlilik"        element={<GizlilikPage />} />

          {/* Portal — passwordless accounts + document signing */}
          <Route path="/login"           element={<LoginPage />} />
          <Route path="/auth/callback"   element={<AuthCallbackPage />} />
          <Route path="/dashboard"       element={<RequireAuth><DashboardPage /></RequireAuth>} />
          <Route path="/account"         element={<RequireAuth><AccountPage /></RequireAuth>} />
          <Route path="/gelistirici"     element={<RequireAuth><DeveloperPage /></RequireAuth>} />
          <Route path="/documents/new"   element={<RequireAuth><ComposeDocumentPage /></RequireAuth>} />
          <Route path="/documents/upload" element={<RequireAuth><UploadDocumentPage /></RequireAuth>} />
          <Route path="/documents/:id"   element={<RequireAuth><DocumentDetailPage /></RequireAuth>} />
          {/* Recipient signing via emailed link — anonymous */}
          <Route path="/s/:token"        element={<RecipientSignPage />} />
          {/* Redirect-session signing (ADR-0006) — anonymous, 3D-Secure tarzı.
              ADR kanonik yolu /s/{id}; ancak /s/:token portal alıcı-imzaya ait
              olduğundan çakışmayı önlemek için /rs/:id kullanıldı. */}
          <Route path="/rs/:id"          element={<RedirectSignPage />} />

          <Route path="*"                element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </HelmetProvider>
  )
}
